import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody33';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy33 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Facilitated IPO planning </h2><h4>through comprehensive market analysis and advisor benchmarking</h4>";

  return (
    <>
        <Helmet>
        <title>Facilitated IPO planning through comprehensive market analysis and advisor benchmarking</title>
        <meta property="og:title" content="Facilitated IPO planning through comprehensive market analysis and advisor benchmarking" />
        <meta property='og:description' content='Facilitated IPO planning through comprehensive market analysis and advisor benchmarking'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy33" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy33 
